<template>
  <div class="employee-manage-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">补卡审批</span>
      </div>
    </div>

    <div class="search-bar">
      <el-date-picker
        v-model="searchForm.dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 240px;"
        @change="handleSearch"
      />
      <el-input placeholder="申请人/原因" v-model="searchForm.keyword" style="width: 150px; margin-left: 10px;" clearable @keyup.enter.native="handleSearch">
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px;">
        <i class="el-icon-search"></i> 查询
      </el-button>
      <el-button @click="handleReset" style="margin-left: 10px;">
        <i class="el-icon-refresh"></i> 重置
      </el-button>
    </div>

    <div class="content-wrapper">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="main-tabs">
        <el-tab-pane label="待审批" name="PENDING" />
        <el-tab-pane label="已通过" name="APPROVED" />
        <el-tab-pane label="已拒绝" name="REJECTED" />
        <el-tab-pane label="全部" name="" />
      </el-tabs>

      <el-table :data="tableData" v-loading="loading" stripe border style="margin-top: 0;">
        <el-table-column prop="userName" label="申请人" width="100" fixed />
        <el-table-column prop="department" label="部门" width="100" />
        <el-table-column prop="userRole" label="角色" width="80">
          <template slot-scope="scope">
            <el-tag size="small">{{ getRoleName(scope.row.userRole) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="makeupDate" label="补卡日期" width="120" />
        <el-table-column prop="checkinType" label="补卡类型" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.checkinType === 1 ? '上班卡' : '下班卡' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="makeupReason" label="补卡原因" min-width="200" show-overflow-tooltip />
        <el-table-column prop="applyTime" label="申请时间" width="160" />
        <el-table-column label="操作" width="320">
          <template slot-scope="scope" v-if="scope.row.approveStatus === 'PENDING'">
            <el-button type="text" size="small" @click="handleApprove(scope.row)">通过</el-button>
            <el-button type="text" size="small" class="btn-danger" @click="handleReject(scope.row)">拒绝</el-button>
          </template>
          <template slot-scope="scope" v-else>
            <el-tag size="small" :type="scope.row.approveStatus === 'APPROVED' ? 'success' : 'danger'">
              {{ scope.row.approveStatus === 'APPROVED' ? '已通过' : '已拒绝' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-sizes="[20, 50, 100]"
          :page-size="pagination.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>

    <el-dialog
      :title="approveDialog.title"
      :visible.sync="approveDialog.visible"
      width="500px"
    >
      <el-form :model="approveForm" ref="approveForm" label-width="80px">
        <el-form-item label="审批结果">
          <el-radio-group v-model="approveForm.status">
            <el-radio label="APPROVED">通过</el-radio>
            <el-radio label="REJECTED">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批备注">
          <el-input
            v-model="approveForm.remark"
            type="textarea"
            :rows="3"
            :placeholder="approveForm.status === 'REJECTED' ? '请输入拒绝原因' : '选填'"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="approveDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitApprove">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as checkinApi from '@/api/checkinApi.js'

export default {
  name: 'MakeupApproval',
  data() {
    return {
      activeTab: 'PENDING',
      searchForm: {
        dateRange: [],
        keyword: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      approveDialog: {
        visible: false,
        title: '补卡审批'
      },
      approveForm: {
        id: null,
        status: 'APPROVED',
        remark: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    goBack() {
      this.$router.push('/home/workbench')
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          status: this.activeTab,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          keyword: this.searchForm.keyword
        }

        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDate = this.searchForm.dateRange[0]
          params.endDate = this.searchForm.dateRange[1]
        }

        const result = await checkinApi.getMakeupApplicationList(params)

        if (result) {
          this.tableData = result.list || []
          this.total = result.total || 0
        }
      } catch (e) {
        console.error('加载补卡数据失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        dateRange: [],
        keyword: ''
      }
      this.pagination.page = 1
      this.loadData()
    },
    handleTabClick() {
      this.pagination.page = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handlePageChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handleApprove(row) {
      this.approveForm = {
        id: row.id,
        status: 'APPROVED',
        remark: ''
      }
      this.approveDialog.title = '补卡审批 - 通过'
      this.approveDialog.visible = true
    },
    handleReject(row) {
      this.approveForm = {
        id: row.id,
        status: 'REJECTED',
        remark: ''
      }
      this.approveDialog.title = '补卡审批 - 拒绝'
      this.approveDialog.visible = true
    },
    async submitApprove() {
      if (this.approveForm.status === 'REJECTED' && !this.approveForm.remark) {
        this.$message.warning('请输入拒绝原因')
        return
      }

      try {
        await checkinApi.approveMakeup(this.approveForm)
        this.$message.success('审批成功')
        this.approveDialog.visible = false
        this.loadData()
      } catch (e) {
        this.$message.error('审批失败')
      }
    },
    getRoleName(role) {
      const map = {
        'STAFF': '内勤',
        'COACH': '教练',
        'DRIVER': '司机',
        'SALES': '业务员',
        'FINANCE': '财务',
        'HR': '人事'
      }
      return map[role] || role
    }
  }
}
</script>

<style scoped>
.employee-manage-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
  padding-bottom: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.search-bar {
  display: flex;
  align-items: center;
  margin: 15px 20px;
  background: #fff;
  padding: 15px;
  border-radius: 4px;
}

.content-wrapper {
  margin: 0 20px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
}

.main-tabs {
  margin-bottom: 15px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.btn-danger {
  color: #f56c6c;
}
</style>
